import { render } from "./FormCreateCompanySecondary.vue?vue&type=template&id=8e00a75a"
import script from "./FormCreateCompanySecondary.vue?vue&type=script&lang=js"
export * from "./FormCreateCompanySecondary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__